<template>
  <div class="vs-timeline" :style="customCssVariable">
    <ol class="vs-timeline-list">
      <slot />
    </ol>
  </div>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue'
import { useElementSize } from '@vueuse/core'

const props = defineProps<{
  lastItem: any
}>()

const lastItemRef = toRef(props, 'lastItem')
const { height: heightOfLastElementOfVsTimeline } = useElementSize(lastItemRef)

const customCssVariable = computed(() => ({
  '--timeline-height': `${heightOfLastElementOfVsTimeline.value}px`,
}))
</script>

<style scoped>
.vs-timeline {
  margin-left: -1.5em;
}

.vs-timeline-list {
  position: relative;
  list-style: none;
}

.vs-timeline-list::before {
  content: '';
  position: absolute;
  inset: 1.5rem auto 1.5rem 2.2rem;
  border: 0.1rem dashed darkgray;
  z-index: 1;
  /* noinspection CssUnresolvedCustomProperty */
  height: calc(100% - var(--timeline-height));
}
</style>
